export default __webpack_public_path__ + "static/media/jcb.6617c4d2.svg";